import * as React from "react"
import {Box, Stack, Typography, Link, Icon} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import {formatDate} from "@ui-seeker/utils";

import {LabelCountry, SkuInfoBlock} from "@components";
import {LinkIconBlock} from "@components";
import { useBuildExternalURL } from "@hooks"


export default function ProductPagesModalSkuBlock({ brand, company, sku, siteID, productID, date, ean, category, country, retailer, siteURL, brandRaw, supertitle, subtitle, productTitle }) {

	const { productURL: url } = useBuildExternalURL({ siteData: { siteID, productID } })
	return <>
		<Stack direction="column" sx={{ textAlign: "start" }}>

			<Typography variant="h6" sx={{ mb: 1, fontWeight: 'regular'  }}>
				{supertitle?.length ? supertitle : brandRaw}
			</Typography>

			{!!productTitle?.length && <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2}}>
				<Link url={url} variant="body2" href={url} target="_blank" sx={{ cursor: "pointer", color: 'text.primary'}}>
					<Typography variant="h5" sx={{ mb: 1 }}>{productTitle}</Typography>
				</Link>
				<IconSeeker icon={'up-right-from-square'} sx={{ color: 'primary.main' }} />
			</Box>}

			{!!subtitle?.length && <Typography variant="h6" sx={{ mb: 1, fontWeight: 'regular' }}>
				{subtitle}
			</Typography>}

			{!!category && <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
				Category: {category}
			</Typography>}

			{!!brand && <Typography variant="subtitle2" sx={{  color: "text.primary" }}>
				Brand in Product Page: {brandRaw}
			</Typography>}

			{ !!ean && <Typography variant="subtitle2" sx={{ color: "text.primary", mb: 1 }}>
				EAN: {ean}
			</Typography> }

			<Typography variant="body2" >{formatDate(date, { isString: true })}</Typography>

		</Stack>
		<Box>
			<LabelCountry country={country} label={retailer} url={siteURL} />
		</Box>
	</>
}